/** Russian words of the grammar: months (genitive), weekdays, small numbers. */

/** Month stems in the genitive ("25 октября"); index + 1 = month number. */
export const MONTHS_GENITIVE = [
  'января',
  'февраля',
  'марта',
  'апреля',
  'мая',
  'июня',
  'июля',
  'августа',
  'сентября',
  'октября',
  'ноября',
  'декабря',
] as const;

/** English month names (full). */
export const MONTHS_EN = [
  'january',
  'february',
  'march',
  'april',
  'may',
  'june',
  'july',
  'august',
  'september',
  'october',
  'november',
  'december',
] as const;

/** English weekday names (full), 0 = Monday ... 6 = Sunday. */
export const WEEKDAYS_EN = [
  'monday',
  'tuesday',
  'wednesday',
  'thursday',
  'friday',
  'saturday',
  'sunday',
] as const;

/** Weekday stems; 0 = Monday ... 6 = Sunday. A word is the stem plus a short ending. */
export const WEEKDAY_STEMS = [
  'понедельник',
  'вторник',
  'сред',
  'четверг',
  'пятниц',
  'суббот',
  'воскресень',
] as const;

export const NUMBER_WORDS: Record<string, number> = {
  один: 1,
  одна: 1,
  одну: 1,
  два: 2,
  две: 2,
  три: 3,
  четыре: 4,
  пять: 5,
  шесть: 6,
  семь: 7,
  восемь: 8,
  девять: 9,
  десять: 10,
  одиннадцать: 11,
  двенадцать: 12,
};

/** `(?<![\p{L}\p{N}])` / `(?![\p{L}\p{N}])`: word edges that also work for Cyrillic. */
export const START = '(?<![\\p{L}\\p{N}])';
export const END = '(?![\\p{L}\\p{N}])';

const numberAlternatives = Object.keys(NUMBER_WORDS).join('|');
/** A quantity: digits (1-3) or a word. */
export const NUMBER = `(\\d{1,3}|${numberAlternatives})`;

export function numberOf(token: string): number {
  return NUMBER_WORDS[token] ?? Number(token);
}

/** Phrases that look like a time expression but are not in the grammar: reported, not guessed. */
export const UNSUPPORTED_WORDS: readonly string[] = [
  'утром',
  'вечером',
  'днём',
  'днем',
  'ночью',
  'через',
  'следующ',
  'неделе',
  'выходных',
  'числа',
  'месяце',
  'года',
  'кажд',
  'ежедневн',
  'еженедельн',
  'ежемесячн',
  'ежегодн',
];
